<template>
  <el-drawer :title="drawerTitle" :visible.sync="localVisible" direction="rtl" size="700px" append-to-body>
    <div class="drawer-wrap">
      <div v-if="loading" class="drawer-loading">
        <i class="el-icon-loading"></i>
        <span>加载中...</span>
      </div>
      <div v-else-if="!dataList.length" class="drawer-empty">
        <i class="el-icon-document"></i>
        <div>暂无字典数据</div>
      </div>
      <template v-else>
        <el-row :gutter="12" class="stat-row">
          <el-col :span="disabledCount > 0 ? 8 : 12">
            <div class="stat-card">
              <div class="stat-num">{{ dataList.length }}</div>
              <div class="stat-label">共计条目</div>
            </div>
          </el-col>
          <el-col :span="disabledCount > 0 ? 8 : 12">
            <div class="stat-card">
              <div class="stat-num success">{{ normalCount }}</div>
              <div class="stat-label">正常</div>
            </div>
          </el-col>
          <el-col :span="8" v-if="disabledCount > 0">
            <div class="stat-card">
              <div class="stat-num danger">{{ disabledCount }}</div>
              <div class="stat-label">停用</div>
            </div>
          </el-col>
        </el-row>
        <div v-for="item in dataList" :key="item.dictCode" class="dict-item">
          <div class="dict-cell">
            <div class="dict-cell-key">标签</div>
            <div class="dict-cell-val">
              <el-tag v-if="item.listClass && item.listClass !== 'default'" :type="item.listClass === 'primary' ? '' : item.listClass" size="small">{{ item.dictLabel }}</el-tag>
              <span v-else>{{ item.dictLabel }}</span>
            </div>
          </div>
          <div class="dict-cell">
            <div class="dict-cell-key">键值</div>
            <div class="dict-cell-val">{{ item.dictValue }}</div>
          </div>
          <div class="dict-cell">
            <div class="dict-cell-key">状态</div>
            <div class="dict-cell-val">
              <el-tag :type="item.status === '0' ? 'success' : 'danger'" size="small">
                {{ item.status === '0' ? '正常' : '停用' }}
              </el-tag>
            </div>
          </div>
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
import { listData } from '@/api/system/dict/data'

export default {
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      localVisible: false,
      loading: false,
      dataList: []
    }
  },
  computed: {
    drawerTitle() {
      return this.row.dictName + '　' + (this.row.dictType || '')
    },
    normalCount() {
      return this.dataList.filter(r => r.status === '0').length
    },
    disabledCount() {
      return this.dataList.filter(r => r.status !== '0').length
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
    },
    localVisible(val) {
      this.$emit('update:visible', val)
      if (val) {
        this.loadData()
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    loadData() {
      if (!this.row || !this.row.dictType) return
      this.loading = true
      this.dataList = []
      listData({ dictType: this.row.dictType, size: 100, current: 1 }).then(response => {
        this.dataList = response.rows || []
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
